import React, { useState, useEffect, useRef } from "react";
import {fileNameType} from "../../utils/helpers";
import Config from "../../Config.json";
import Modal from './../module.modal';
import Icons from '../module.icons';
import Versions from '../module.versions';
import { apiCall } from "./../narrativeUtils/fetch";
import classNames from "classnames";

function PageSettings(props) {
  const pipLocRef = useRef();
  const [showGenerateScreenshot, setShowGenerateScreenshot] = useState(true);
  const [active, setActive] = useState(props.activeSectionObj ? props.activeSectionObj['active'] : false);
  const [pipLoc, setPipLoc] = useState(props.activeSectionObj ? props.activeSectionObj['pip_loc'] : null);

  function handleSectionScreenShot(e) {
    props.setShowLoader(true);
    const api_url = Config.baseURLcms + 'section-screenshot/';
    setShowGenerateScreenshot(false);
    var dataJSON = {
      'id': props.activeSectionObj.id,
    }
    function responseTask(response){
     
      // console.log('handleSectionScreenShot', response.data)
      props.setSectionId(response.data); 
      setShowGenerateScreenshot(true);
      props.setShowLoader(false);
      props.fetchJSON(false);
    }
    apiCall('POST', api_url, dataJSON, responseTask)

  }

  function onSetSections(objId, newObj0) {
    let newSections = [ ...props.sections ];
    let objIndex = newSections.findIndex(section => section.id === objId)
    newSections[objIndex] = newObj0
    
    props.setSections(newSections)
    props.setSectionChanges(newSections);
    props.setUnSavedChanges(true);
    // props.handleLayerSave();

   

    // console.log('newSections', newSections)
  }

  function handleSectionActive() {
    props.handleSectionActive(!active)
    setActive(!active)
  }


  // Only reset state when switching to a different page, not on refetches
  useEffect(() => {
    if (props.activeSectionObj) {
      setActive(props.activeSectionObj['active'])
      setPipLoc(props.activeSectionObj['pip_loc'] || null)
    }
  }, [props.activeSectionObj?.id]) // eslint-disable-line react-hooks/exhaustive-deps


  function onPipLoc(value){
    setPipLoc(value);
    props.handlePipLoc(value);

   
  } 

  function handleSaveAsTemplate(e){
    
    const api_url = Config.baseURLcms + 'section-to-template/';
    let formData = {}
    formData['obj_id'] = props.activeSectionObj.id
    function responseTask() {
      if (props.templateId){
      window.location.href = "/narratives/" + props.templateId + '/pages?back=' + props.narrativeId + ',' + props.activeSectionObj.id
      }
    }
    apiCall("POST", api_url, formData, responseTask)
  }
    
    return(
       <div className="rightNav settingsOn" id="manifestColumn">
        <div className={"mediaSettings showSettings on"}>

          <div className="settingsGroup">
            <div className="groupLabel"><p>Page Settings</p></div>
            {props.activeSectionObj &&(
              <div className="settingsRow">
              <div className="sectionHeading" id={"section_" + props.activeSectionObj.id} key={'sectionHeading_' + props.activeSectionObj.id}>
              <div className="fieldRow">
                  <div className="errors"></div>
                    
                    <div className="canvasLabel">Title</div>
                    <input type="text" autoComplete="off" id="sectionTitle" key={props.activeSectionObj.nav.heading} defaultValue={props.activeSectionObj.nav && props.activeSectionObj.nav.heading} onKeyUp={(e) => props.handleOnKeyUp(e, 'narrativeHeading', props.activeSectionObj.nav.id)} />
                 
              </div>
              
              </div>
              </div>
              )}

            <div className="selectFileRow">
      
              <div className="canvasLabel">Background</div>
              {props.componentDimensions
                .filter(obj0 => obj0.background === true)
                .map((dimension, i) => 
                <div 
                  id={"settings_" + dimension.id}  
                  onClick={(e) => props.showSettings(dimension.id, false, null)}
                  key={'settingFile_' + i}>
                    <div onClick={() => props.showSettings(dimension.id, false, null)}>
                      <div className="iconField ui">{dimension.image ? fileNameType(dimension.name, dimension.layer_name).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>)): <div className="flex alignCenter gap10"><span className="ui colorChip" style={{ background: (dimension.background_color) ? (dimension.background_color) :"none"}}></span><span>{dimension.background_color}</span></div>}</div>
                      
                    </div>
                    
                </div>
                )}

            </div>
            
            <div className="selectFileRow">
                <span className="canvasLabel">{props.activeSectionObj.screenshot_for_pdf && <a href={Config.mediaURL + props.activeSectionObj.screenshot_for_pdf} rel="noreferrer" target="_blank">Screenshot for PDF</a>}</span>
              {showGenerateScreenshot && <span className="iconField ui" onClick={(e) => handleSectionScreenShot(e)}><Icons.Sync className="icon" /> Update Thumbnail </span>}
              {props.activeSectionObj.screenshot_for_pdf && <img src={Config.mediaURL + props.activeSectionObj.screenshot_for_pdf} className="thumbnail" alt="" />}
            </div>


            {(!props.activeSectionObj.template ) && <div className="selectFileRow">
              <span className="canvasLabel"></span>
              {showGenerateScreenshot && <span className="iconField ui" onClick={(e) => handleSaveAsTemplate(e)}><Icons.AddTemplate className="icon" /> Save as Template </span>}
            </div>}
              
            <div className="settingsRow" style={{display: "none"}}>
            <span className="canvasLabel">Tablet Scroll Offset</span>
            <input type="text" onChange={(e) => props.handleSectionScrollOffset(e)} defaultValue={props.activeSectionObj.scroll_offset} key={props.activeSectionObj.scroll_offset + props.activeSectionObj.id} id={'section_scroll_offset_' + props.activeSectionObj.id} />
          </div>

            <div className={"settingsRow halfRow"}>
            <span className="canvasLabel">Visibility</span>
            <div className="iconField settingsRow ui" onClick={() => handleSectionActive()}>{(active) ? <Icons.Visible className="icon" /> : <Icons.VisibleOff className="icon" />}
            </div>
            
            </div>

            <div className="settingsRow">
            <div className="settingsRow halfRow">
            <span className="canvasLabel">PIP Location</span>
            {props.activeSectionObj && <div className="iconField settingsRow ui" >

              <span 
              className={classNames(
                "btn1",
                pipLoc === "left" && "on"
                )} 
              onClick={() => onPipLoc('left')}>Left</span>
              <span className={classNames(
                "btn1",
                pipLoc === "right" && "on"
                )} onClick={() => onPipLoc('right')}>Right</span>

                <span style={{marginLeft: '10px'}} onClick={() => onPipLoc(null)}>Clear</span>
            </div>}
   
            </div>
            </div>
          </div>

          <div className="settingsRow sectionSave" id="saveRow">
          <div className={"closeFormBtn btn" + ((props.unSavedChanges) ? (" unsaved") : (" saved"))} onClick={() => props.handleSectionOnlySave()}>Save</div> 
            <div className="iconField ui rightNavDeleteBtn" onClick={() => props.setShowDeleteSection(props.activeSectionObj.id)}><Icons.Delete className="icon"/> <div className="canvasLabel">Delete Page</div></div>
          </div>
          
          <div className="settingsGroup">
            <Versions 
              contentTypeId={14}
              location={"page"}
              obj={props.activeSectionObj}
              setObj={onSetSections} 
              user={props.user}
              saveObj={props.handleSectionOnlySave}
              setUnSavedChanges={props.setUnSavedChanges}
              setSectionChanges={props.setSectionChanges}
              setForceVersion={props.setForceVersion}
            />

          </div>

          
        </div>                         
      </div>
    )
}

export default PageSettings;